/**
 * Global search — the contract behind the TopBar's search box.
 *
 * `GET /api/search?q=<term>` returns ONE object with a fixed set of group keys.
 * The groups are always present, always arrays, and an empty array is
 * deliberately ambiguous: it means "no matches" AND "your role cannot view this
 * module", and the caller cannot tell which. That is the point — see the
 * existence-oracle note on `SearchService`.
 */
/**
 * Which group an item came from. Drives the frontend's route prefix.
 *
 * Extended 2026-11-03 (Part D) from the original four (lead/customer/
 * booking/tour) to also cover invoice/payment/creditNote/voucher/expense —
 * `expense` is the only one with its own extra permission gate
 * (`EXPENSE_TRACKING`, not one of the four this service already resolved).
 */
export const SEARCH_ENTITY_TYPES = [
    'lead', 'customer', 'booking', 'tour', 'invoice', 'payment', 'creditNote', 'voucher', 'expense',
];
/**
 * Shorter than this and the server does not query at all — it returns the empty
 * result immediately. There is no index behind the `contains` scans (only
 * `Customer.name` is indexed, and not for a substring match), so a one-character
 * term would sequentially scan four tables to return most of the database.
 */
export const SEARCH_MIN_QUERY_LENGTH = 2;
/**
 * Longer than this is REJECTED with 400, not truncated. See the note on
 * `SearchQuery` in the backend for why rejection beats silent truncation.
 */
export const SEARCH_MAX_QUERY_LENGTH = 100;
/** Per-group cap. */
export const SEARCH_PER_TYPE_LIMIT = 5;
/**
 * Overall cap. Satisfied BY CONSTRUCTION today:
 * `SEARCH_ENTITY_TYPES.length * SEARCH_PER_TYPE_LIMIT === 45` (9 × 5). So no
 * cross-group trimming happens and no group is ever preferred over another —
 * which matters, because "which group loses rows" is a product decision nobody
 * has made. `SearchService` asserts the relationship at import time so that
 * adding another group without revisiting this is a boot failure, not a silent
 * change of behaviour.
 */
export const SEARCH_TOTAL_LIMIT = 45;
//# sourceMappingURL=search.js.map